import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import {} from 'lodash';
import { GlobalNavigation } from '..';

const FixedDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export interface IStickyNavigation {
  activeMain?: string;
  hideActions?: boolean;
  onClick?: (href?: string | null) => void;
  onHomeClick?: () => void;
  profile?: React.ReactNode;
}

export const StickyNavigation: React.FC<IStickyNavigation> = ({
  activeMain,
  hideActions,
  onClick,
  onHomeClick,
  profile,
}) => {
  return (
    <>
      <div style={{ height: 100 }} />
      {createPortal(
        <FixedDiv>
          <GlobalNavigation
            active={activeMain}
            isLogoLink
            showActions={!hideActions}
            onHomeClick={onHomeClick}
            onClick={onClick}
            profile={profile}
          />
        </FixedDiv>,
        document.body
      )}
    </>
  );
};
